import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useGetLoadingState } from 'redux/loadingFullScreen/loadingFullScreenSlice';

const LoadingFullScreen = () => {
  const { isLoading } = useGetLoadingState();
  return isLoading ? (
    <Backdrop sx={{ color: '#fff', zIndex: 9999 }} open>
      <CircularProgress color="success" />
    </Backdrop>
  ) : null;
};

export default LoadingFullScreen;
